import { SystemsState } from './systems.types';

/**
 *  Holding the state of the systems.
 */
export const State: { systems: SystemsState; } = {
    systems: {
        loading: false,
        filters: {
            available: [],
            state: {},
        },
        suggestions: {
            single: {},
            multi: {},
            show: null,
            systems: {},
        },
    },
};
